import { render, staticRenderFns } from "./permissionChangeRecords.vue?vue&type=template&id=50891f61"
import script from "./permissionChangeRecords.vue?vue&type=script&lang=js"
export * from "./permissionChangeRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports